(function(angular){
	'use strict';

	angular.module('plansTeaserModule', [
		'coreModule',
		'orderFormModule'
	]).value('globalConfig', globalConfig);

})(window.angular);